import React from 'react';

import { IconBase, IconProps } from './IconBase';

export const IconDot: React.FunctionComponent<IconProps> = ({ ...props }) => (
  <IconBase viewBox="0 0 16 16" {...props}>
    <circle id="dot" cx="8" cy="8" r="3" fill="currentColor" />
  </IconBase>
);
